module.exports = __webpack_public_path__ + "img/3.5f770e81.jpg";